import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
/* Chargé APRÈS `index.css` : à spécificité égale, la dernière règle
   l'emporte. L'ordre compte donc, même si tout le contenu de ce fichier
   est enfermé sous 760 px et ne peut rien changer sur ordinateur. */
import './mobile.css';
import App from './App';
import { appliquerTheme, installerThemes, themeEnregistre } from './theme';

/* Le thème est posé AVANT le premier rendu, et volontairement ici
   plutôt que dans un composant : monté dans un `useEffect`, il ne
   s'appliquerait qu'après le premier affichage. La console apparaîtrait
   en clair une fraction de seconde avant de basculer — un éclair blanc
   en pleine nuit, exactement ce que le thème sombre doit éviter.

   Sans animation à cette étape : la transition ne sert qu'à adoucir une
   bascule VOULUE, pas l'ouverture de la page. */
installerThemes();
appliquerTheme(themeEnregistre());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
